import { useParams, useNavigate } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import Spinner from "../../components/Spinner";

const BlogDetails = () => {
    const { id } = useParams(); // USE PARAMS LIKE JAVASCRIPT , GETTING ADDRESS URL PARAMETERS example: https://blogs.com/5 , you can get the id which is id
    const { data: blog, isLoading, errorMessage } = useFetch(`http://localhost:8000/blogs/${id}`);

    const navigate = useNavigate();

    const handleDelete = () => {
        fetch(`http://localhost:8000/blogs/${id}`,{
            method:"DELETE"
        })
        .then(()=>{
            navigate('/');
        })        
    }
     

    return (

        <>
            {isLoading && <Spinner />}
            {errorMessage && <div>{errorMessage}</div>}
            {blog && (
                <article>
                    <h1>{blog.title}</h1>
                    <p>Written by {blog.author}</p>
                    <div>
                        {blog.body}
                    </div>
                </article>
            )}

            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                    <div className="col-12">
                        <span className="text-danger fw-bold fs-2x">This is a blog details page {id}</span>
                        <button onClick={handleDelete}>Delete</button>
                    </div>
                </div>
            </div>

        </>
    );
}

export default BlogDetails;